export const appRouteSegments = {
  auth: 'auth',
  applications: 'applications',
  atlas: 'atlas',
  rechercheInvestisseur: 'recherche-investisseur',
  rechercheConsultant: 'recherche-consultant',
  investors: 'investisseurs',
  consultants: 'consultants',
  minotaure: 'minotaure',
  technical: 'technique',
  aramis: 'aramis',
  integrationApril: 'integration-april',
  doublonsAriane: 'doublons-ariane',
  doublonsPersonnePhysique: 'doublons-personne-physique',
  relationsInterConsultants: 'relations-inter-consultants',
  bouquetService: 'bouquet-service',
  recueilInterConsultants: 'recueil-inter-consultants',
  reporting: 'reporting',
  batch: 'batch',
  metadata: 'metadata',
  caches: 'caches',
  purgeJobs: 'jobs-purge',
  controleGestion: 'controle-gestion',
  coutsExPost: 'couts-ex-post',
  proxeema: 'proxeema',
  signaturesInvestisseur: 'signatures-investisseur',
  transactionsUniversign: 'transactions-universign',
  anomaliesSignatures: 'anomalies-signatures',
} as const;

const applicationsBasePath = `/${appRouteSegments.applications}`;
const atlasBasePath = `${applicationsBasePath}/${appRouteSegments.atlas}`;
const minotaureBasePath = `${applicationsBasePath}/${appRouteSegments.minotaure}`;
const technicalBasePath = `${applicationsBasePath}/${appRouteSegments.technical}`;
const aramisBasePath = `${applicationsBasePath}/${appRouteSegments.aramis}`;
const controleGestionBasePath = `${applicationsBasePath}/${appRouteSegments.controleGestion}`;
const proxeemaBasePath = `${applicationsBasePath}/${appRouteSegments.proxeema}`;

export const appRoutePaths = {
  home: `${atlasBasePath}/${appRouteSegments.rechercheInvestisseur}`,
  auth: `/${appRouteSegments.auth}`,
  applications: applicationsBasePath,
  atlas: {
    root: atlasBasePath,
    rechercheInvestisseur: `${atlasBasePath}/${appRouteSegments.rechercheInvestisseur}`,
    rechercheConsultant: `${atlasBasePath}/${appRouteSegments.rechercheConsultant}`,
    doublonsAriane: `${atlasBasePath}/${appRouteSegments.doublonsAriane}`,
    doublonsPersonnePhysique: `${atlasBasePath}/${appRouteSegments.doublonsPersonnePhysique}`,
    relationsInterConsultants: `${atlasBasePath}/${appRouteSegments.relationsInterConsultants}`,
    bouquetService: `${atlasBasePath}/${appRouteSegments.bouquetService}`,
    arianeDuplicate: (arianeId: number | string) =>
      `${atlasBasePath}/${appRouteSegments.doublonsAriane}/${arianeId}`,
    investor: (investorId: number | string) =>
      `${atlasBasePath}/${appRouteSegments.investors}/${investorId}`,
    consultant: (consultantId: number | string) =>
      `${atlasBasePath}/${appRouteSegments.consultants}/${consultantId}`,
  },
  minotaure: {
    root: minotaureBasePath,
    reporting: `${minotaureBasePath}/${appRouteSegments.reporting}`,
    recueilInterConsultants: `${minotaureBasePath}/${appRouteSegments.recueilInterConsultants}`,
    batch: `${minotaureBasePath}/${appRouteSegments.batch}`,
    metadata: (metadataId: number | string) =>
      `${minotaureBasePath}/${appRouteSegments.metadata}/${metadataId}`,
  },
  technical: {
    root: technicalBasePath,
    caches: `${technicalBasePath}/${appRouteSegments.caches}`,
    purgeJobs: `${technicalBasePath}/${appRouteSegments.purgeJobs}`,
  },
  aramis: {
    root: aramisBasePath,
    integrationApril: `${aramisBasePath}/${appRouteSegments.integrationApril}`,
  },
  controleGestion: {
    root: controleGestionBasePath,
    coutsExPost: `${controleGestionBasePath}/${appRouteSegments.coutsExPost}`,
    coutsExPostCampaign: (campaignId: number | string) =>
      `${controleGestionBasePath}/${appRouteSegments.coutsExPost}/${campaignId}`,
  },
  proxeema: {
    root: proxeemaBasePath,
    signaturesInvestisseur: `${proxeemaBasePath}/${appRouteSegments.signaturesInvestisseur}`,
    signaturesInvestisseurDetail: (investorId: number | string) =>
      `${proxeemaBasePath}/${appRouteSegments.signaturesInvestisseur}/${investorId}`,
    transactionsUniversign: `${proxeemaBasePath}/${appRouteSegments.transactionsUniversign}`,
    anomaliesSignatures: `${proxeemaBasePath}/${appRouteSegments.anomaliesSignatures}`,
  },
  legacy: {
    report: '/report',
    batch: '/batch',
    metadata: (metadataId: number | string) => `/metadata/${metadataId}`,
  },
} as const;
